module.exports = __webpack_public_path__ + "img/button-s_blackLP.c08be76.png";